export default "__VITE_ASSET__BgOi379f__"